export const isHavingAnInvalidCharacter = value => {
  if (!value) {
    return false;
  }

  const regex = /[\\<>[\]{}&()]/;
  return !!regex.test(value);
};
